
import { gmapApi } from 'vue2-google-maps'
//import ContactForm from '~/components/ContactForm.vue'
const mapMarker = require('~/assets/img/contact/mapmarker.png')

export default {
  props: {
    locations: {
      type: Array,
      required: true
    },
    marker: {
      type: String,
      required: true
    },
    setManagers: {
      type: Function,
      required: false
    }
  },
  data() {
    return {
      showMap: false,
      svgLoaded: [],
      svgFillColor: '#fff',
      selected:
        this.locations.length > 0
          ? this.locations[0].location_name[0].text
          : null,
      open: false,
      currentFocus: 8,
      mapType: 'roadmap',
      bounds: null,
      currentLocation: [],
      zoom: 10,
      mapStyle: {
        mapTypeControl: false,
        mapTypeControlOptions: {
          style: 1,
          position: 2
        },
        zoomControl: false,
        zoomControlOptions: {
          position: 3
        },
        scaleControl: true,
        streetViewControl: false,
        streetViewControlOptions: {
          position: 5
        },
        fullscreenControl: false,
        fullscreenControlOptions: {
          position: 1
        },
        styles: [
          {
            featureType: 'landscape',
            stylers: [
              {
                saturation: -100
              },
              {
                lightness: 65
              },
              {
                visibility: 'on'
              }
            ]
          },
          {
            featureType: 'poi',
            stylers: [
              {
                saturation: -100
              },
              {
                lightness: 51
              },
              {
                visibility: 'simplified'
              }
            ]
          },
          {
            featureType: 'road.highway',
            stylers: [
              {
                saturation: -100
              },
              {
                visibility: 'simplified'
              }
            ]
          },
          {
            featureType: 'road.arterial',
            stylers: [
              {
                saturation: -100
              },
              {
                lightness: 30
              },
              {
                visibility: 'on'
              }
            ]
          },
          {
            featureType: 'road.local',
            stylers: [
              {
                saturation: -100
              },
              {
                lightness: 40
              },
              {
                visibility: 'on'
              }
            ]
          },
          {
            featureType: 'transit',
            stylers: [
              {
                saturation: -100
              },
              {
                visibility: 'simplified'
              }
            ]
          },
          {
            featureType: 'administrative.province',
            stylers: [
              {
                visibility: 'off'
              }
            ]
          },
          {
            featureType: 'water',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'on'
              },
              {
                lightness: -25
              },
              {
                saturation: -100
              }
            ]
          },
          {
            featureType: 'water',
            elementType: 'geometry',
            stylers: [
              {
                hue: 'ffff00'
              },
              {
                lightness: -25
              },
              {
                saturation: -97
              }
            ]
          }
        ]
      },
      center: {
        lat: 48.1065497,
        lng: 4.1958815
      },
      markerOptions: {
        url: mapMarker,
        size: { width: 17, height: 17, f: 'px', b: 'px' },
        scaledSize: { width: 17, height: 17, f: 'px', b: 'px' }
      },
      choosenArea: 'All'
    }
  },
  computed: {
    google: gmapApi,
    markers() {
      return this.currentLocation
    },
    /* alphabetic() {
      return this.locations.sort()
    }, */
    buttonClass() {
      return this.textColor == 'inherit' ? 'btn-outline-primary' : 'btn-light'
    }
  },
  mounted() {
    var interv = setInterval(() => {
      if (this.google) {
        clearInterval(interv)
        this.setSearchedPlaces()
        this.$emit('input', this.selected)
      }
    }, 500)
    //default choice
    this.selected = 'Hamburg'
    //
  },
  methods: {
    alphabeticSort(locations) {
      const arr = [...locations]
      const sortedbyArea =
        this.choosenArea === 'All'
          ? arr
          : arr.filter((a) => a.economic_area === this.choosenArea)
      return sortedbyArea.sort((a, b) =>
        a.location_name[0].text.localeCompare(b.location_name[0].text)
      )
    },
    getRightIndex(cityName) {
      /* console.log('get index of ', cityName) */
      const arr = [...this.locations]
      arr.forEach((element, index) => {
        if (element.location_name[0].text === cityName) {
          /* console.log(this.locations[index])
          console.log(index) */
          this.currentFocus = index
          this.setBounds()
          this.setManagers(this.locations[index])
        }
      })
      //console.log(this.locations.findIndex(location_name[0].text === cityName))
    },
    changeChoosenArea(area) {
      this.choosenArea = area
    },
    changeShowMap() {
      //console.log(this.showMap)
      this.showMap = true
    },
    pushSVGLoaded(idx) {
      this.svgLoaded.push(idx)
    },
    getNormalizedPhoneNo(str) {
      return (
        'tel:' +
        str.replace(/\s/gi, '').replace(/\(0\)/gi, '').replace(/-/gi, '')
      )
    },
    getLineBreaksArr(str) {
      return str.split(/\n/gm)
    },
    getItemClass(idx) {
      let className =
        this.currentFocus == idx
          ? 'item selected-item d-flex align-items-center'
          : 'item d-flex align-items-center'
      return this.showSimpleSVG ? className : className + ' d-none'
    },
    changeFocus(idx) {
      /* console.log(idx) */
      this.currentFocus = idx
      this.setBounds()
    },
    setSearchedPlaces() {
      let google = this.google
      this.locations.forEach((location) => {
        let latLng = new google.maps.LatLng(
          location.location_latitude[0].number,
          location.location_longitude[0].number
        )
        this.currentLocation.push({
          position: {
            lat: latLng.lat(),
            lng: latLng.lng()
          },
          title:
            'Trakken Web Services GmbH - ' + location.location_name[0].text,
          icon: {
            path: google.maps.SymbolPath.CIRCLE,
            scale: 8.5,
            fillColor: '#F00',
            fillOpacity: 0.4,
            strokeWeight: 0.4
          },
          animation: google.maps.Animation.DROP
        })
        this.setBounds()
      })
    },
    fitMap() {
      this.$refs.mapRef.$mapPromise.then((map) => {
        setTimeout(() => {
          map.panToBounds(this.bounds)
          map.fitBounds(this.bounds)
          map.set('zoom', 12)
          // if (map.zoom > 12) {
          //   map.set('zoom', 12)
          // } else if (map.zoom < 7) {
          //   map.set('zoom', 7)
          // }
        }, 800)
      })
    },
    setBounds() {
      if (!this.showMap) {
        return
      }
      this.currentLocation.forEach((location, idx) => {
        if (idx == this.currentFocus) {
          let google = this.google
          this.bounds = new google.maps.LatLngBounds()
          this.bounds.extend({
            lat: location.position.lat,
            lng: location.position.lng
          })
        }
      })
      this.fitMap()
    }
  },
  components: {
    //ContactForm
  }
}
